import { useContext } from "react";

import { OrgContext } from "@providers";

export const useHasFeature = (name: string) => {
  const { org } = useContext(OrgContext);
  return org?.features?.find((f) => f.name === name);
};
